import { useCategories } from 'pages/inventory/hooks/useCategories'
import CategoriesIndex from 'pages/inventory/components/category/CategoriesIndex'
import ModalFormCategories from 'pages/inventory/components/category/ModalFormCategories'

export default function Categories() {
  const useCategoriesHook = useCategories()

  return (
    <div className="content-wrapper">
      {useCategoriesHook.toastContainer}
      <CategoriesIndex
        fetchStatus={useCategoriesHook.fetchStatusCategories}
        categories={useCategoriesHook.categories}
        page={useCategoriesHook.pageCategories}
        limit={useCategoriesHook.limitPageCategories}
        totalRows={useCategoriesHook.totalRowsCategories}
        keywordSearch={useCategoriesHook.searchKeywordCategories}
        onChangePage={useCategoriesHook.changePageCategories}
        onChangeLimit={useCategoriesHook.changeLimitPageCategories}
        onChangeKeyword={useCategoriesHook.changeCategroiesKeyword}
        onOpenModal={useCategoriesHook.openModalForm}
        onSearch={useCategoriesHook.searchCategoriesByKeyword}
        onFetch={useCategoriesHook.fetchCategories}
      />
      <ModalFormCategories
        isOpen={useCategoriesHook.isModalOpenFormCategories}
        isLoading={useCategoriesHook.submitStatusFormCategories === 'loading'}
        initForm={useCategoriesHook.initFormCategory}
        categoryId={useCategoriesHook.categoryId}
        onSubmit={useCategoriesHook.submitCategory}
        onCancel={useCategoriesHook.closeModalForm}
      />
    </div>
  )
}
